import React, { useId, useState } from 'react';

function UpdateText({ text }) {
  // Support inline [label](URL) links; keep other content as plain text.
  const pattern = /\[([^\]\n]+)\]\((https?:\/\/[^\s)]+|mailto:[^\s)]+)\)/g;
  const parts = [];
  let start = 0;
  for (const match of text.matchAll(pattern)) {
    parts.push(text.slice(start, match.index));
    parts.push(<a key={match.index} href={match[2]}>{match[1]}</a>);
    start = match.index + match[0].length;
  }
  parts.push(text.slice(start));
  return <>{parts}</>;
}

function Update({ entry }) {
  return (
    <div className="update">
      <time dateTime={entry.date}>{entry.date.replace(/-/g, '.')}</time>
      <p><UpdateText text={entry.text} /></p>
    </div>
  );
}

export default function Updates({ entries }) {
  const [expanded, setExpanded] = useState(false);
  const archiveId = useId();
  // ISO dates sort chronologically without timezone conversions.
  const [latest, ...older] = [...entries].sort((a, b) => b.date.localeCompare(a.date));
  if (!latest) return null;

  return (
    <section className="updates" aria-labelledby="updates-heading">
      <h2 id="updates-heading">Updates</h2>
      <Update entry={latest} />
      {older.length > 0 && (
        <>
          <div id={archiveId} hidden={!expanded}>
            {older.map((entry, index) => <Update key={`${entry.date}-${index}`} entry={entry} />)}
          </div>
          <button
            className="updates-toggle"
            type="button"
            aria-expanded={expanded}
            aria-controls={archiveId}
            onClick={() => setExpanded(value => !value)}
          >
            <span>{expanded ? 'Show less' : `More updates (${older.length})`}</span>
            <svg viewBox="0 0 17 11" aria-hidden="true"><path d="m1 1 7.5 9L16 1" /></svg>
          </button>
        </>
      )}
    </section>
  );
}
